<template>
  <div>
    <span
      v-if="
        keyword.keywordContents.filter((content) => {
          return content.language == 'de-CH';
        })[0]
      "
    >
      {{
        keyword.keywordContents.filter((content) => {
          return content.language == "de-CH";
        })[0].value
      }}
    </span>
    <span v-else> - </span> /
    <span
      v-if="
        keyword.keywordContents.filter((content) => {
          return content.language == 'fr-CH';
        })[0]
      "
    >
      {{
        keyword.keywordContents.filter((content) => {
          return content.language == "fr-CH";
        })[0].value
      }}
    </span>
    <span v-else> - </span> /
    <span
      v-if="
        keyword.keywordContents.filter((content) => {
          return content.language == 'it-CH';
        })[0]
      "
    >
      {{
        keyword.keywordContents.filter((content) => {
          return content.language == "it-CH";
        })[0].value
      }}
    </span>
    <span v-else> - </span>
  </div>
</template>

<script>
export default {
  props: {
    keyword: {
      type: Object,
      required: true,
    },
  },
};
</script>
